import { http } from 'vue'

export default {
  // store maintenance to the API server
  postMaintenance (context, params = {}) {
    return http.post('maintenances/?company_id=' + params.companyId, params.data)
  },
  // store maintenance to the API server
  postSkuMaintenance (context, params = {}) {
    return http.post('sku_maintenances/?company_id=' + params.companyId, params.data)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/maintenances/actions.js